'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _lodash = require('lodash');
var _lodash2 = _interopRequireDefault(_lodash);
var _reactI18next = require('react-i18next');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  expandButton: {
    cursor: 'pointer',
    fontWeight: 'bold'
  }
};
var ExpandableText = function (_Component) {
  _inherits(ExpandableText, _Component);
  function ExpandableText(props) {
    _classCallCheck(this, ExpandableText);
    var _this = _possibleConstructorReturn(this, (ExpandableText.__proto__ || Object.getPrototypeOf(ExpandableText)).call(this, props));
    _this.toggleExpanded = function () {
      _this.setState({
        expanded: !_this.state.expanded
      });
    };
    _this.canExpand = function () {
      var _this$props = _this.props,
        text = _this$props.text,
        maxChars = _this$props.maxChars;
      return !!text && text.length > maxChars;
    };
    _this.getText = function () {
      var _this$props2 = _this.props,
        text = _this$props2.text,
        maxChars = _this$props2.maxChars;
      if (_this.state.expanded || !_this.canExpand()) {
        return text;
      } else {
        return _lodash2.default.trim(text.substring(0, maxChars)) + '...';
      }
    };
    _this.state = {
      expanded: false
    };
    return _this;
  }
  _createClass(ExpandableText, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        text = _props.text,
        classes = _props.classes,
        t = _props.t;
      if (this.canExpand()) {
        return _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement('div', {
          dangerouslySetInnerHTML: {
            __html: this.getText()
          }
        }), _react2.default.createElement('div', {
          className: classes.expandButton,
          onClick: this.toggleExpanded
        }, this.state.expanded ? t('text.see_less') : t('text.read_more')));
      } else {
        return _react2.default.createElement('div', {
          dangerouslySetInnerHTML: {
            __html: text
          }
        });
      }
    }
  }]);
  return ExpandableText;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)((0, _reactI18next.translate)('Misc')(ExpandableText));